/**
 * Created at 2023/08/18
 */
import { filterCompletionFields, getReducedFieldsByShape } from './dimension';
import { BPSymbol } from './symbols';

/**
 * Calculate completion percentage of a symbol in real time of symbol correction
 * FIXME: '0' input not a valid size to count for completion value
 * @2023/11/08
 *
 * @param symbol
 * @param fields dimension properties without 'system'
 * @returns
 */
export const completionCalculator = (
  symbol: BPSymbol,
  fields: string[],
  hasSystemDefined: boolean,
): number => {
  const dimensions = symbol.detail;
  if (!dimensions) return 0;
  // FIXME: check no fields but `system` field case:
  // such as `TOILET`
  // @2024/12/06
  if (!fields.length && dimensions['system']) return 100;
  // check `shape`
  const { shape } = symbol.detail;
  if (fields.length == 0) return 0;
  const completionFields = filterCompletionFields(fields);
  const reducedFields = getReducedFieldsByShape(completionFields, shape);
  const finalFieldsForCompletion = hasSystemDefined
    ? [...reducedFields, 'system']
    : reducedFields;
  // re-evaluate share size!
  const eachShare = Math.ceil(100 / finalFieldsForCompletion.length);
  const completion = finalFieldsForCompletion.reduce(
    (total: number, field: string) => {
      const validInput = !!dimensions[field] && dimensions[field] !== '0';
      return validInput ? total + eachShare : total;
    },
    0,
  );
  // console.log({ completion });
  // FIXME: sometimes, the whole cells filled, but the completion is 99
  // so, +1 is required to make it `completed`!
  // @2023/11/10
  if (completion >= 99) return 100;

  return Math.min(completion, 100);
};
